/* eslint-disable */
const HelperMethods = {
  getAuthenticationToken: async () => {
    // Token retrival logic goes here
  },
  sleepTime: n => new Promise(r => setTimeout(() => r(), n)),
  prependAreaCodeIfRequired: phoneNumber => {
    if (phoneNumber && phoneNumber.length) {
      if (phoneNumber.indexOf("+1") === 0) {
        return phoneNumber;
      } else {
        return `+1${phoneNumber}`;
      }
    }
    return null;
  },
  validateMessagePlaceholders: message => {
    let isValid = true;
    if (message.indexOf("{{FirstName}}") > -1 && message.indexOf("{{LastName}}") > -1) {
      isValid = false;
    }
    return isValid;
  }
};

export default HelperMethods;
